module.exports = __webpack_public_path__ + "img/page-07.c3151371.png";